"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/** Skeleton for offer. Displays empty rectangle. */ const OfferSkeleton = (param)=>{
    let { animation = 'pulse', className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Skeleton, {
        "data-testid": getTestId(_models.TestId.OfferSkeleton),
        animation: animation,
        className: className,
        variant: "rectangular",
        width: "100%",
        height: 808
    });
};
exports.OfferSkeleton = OfferSkeleton;
